import script from "./DepartmentsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentsView.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentsView.vue?vue&type=style&index=0&id=cf9eefca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf9eefca"]])

export default __exports__